module.exports = __webpack_public_path__ + "static/media/CheckBox.2c5c8079.svg";